<template>
  <div class="products-sidebar mt-2 mt-lg-4">
    <span class="d-block fw-semi-bold text-black"> Dit pakket bevat: </span>

    <div v-if="hasGroupedProducts">
      <div
        v-for="type in [
          'producten',
          'eten-drinken',
          'verpakking',
          'brievenbus',
        ]"
        :key="type"
      >
        <template v-if="grouped[type] && grouped[type].length > 0">
          <a
            class="products-sidebar__toggle"
            data-bs-toggle="collapse"
            :data-bs-target="`#collapse-${type}`"
            aria-expanded="true"
            :aria-controls="`collapse-${type}`"
          >
            {{ getCategoryTitle(type) }}
            <i class="icon icon-chevron"></i>
          </a>

          <div class="collapse show" :id="`collapse-${type}`">
            <div class="row flex-column gy-2">
              <div
                v-for="product in grouped[type]"
                :key="product.id"
                class="col"
              >
                <div
                  class="products-sidebar__item products-sidebar__item--clickable"
                  @click="openProductModal(product)"
                >
                  <figure class="products-sidebar__img">
                    <img
                      v-if="product.image"
                      :src="product.image"
                      :alt="product.name"
                      loading="lazy"
                    />
                  </figure>
                  <span class="products-sidebar__title">
                    {{
                      (product.quantity > 1 ? product.quantity + 'x ' : '') +
                      decodeHtml(product.name)
                    }}
                  </span>
                  <span
                    class="products-sidebar__price"
                    v-html="product.priceHtml"
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <p v-else class="text-muted">Geen producten gevonden in dit pakket.</p>
  </div>

  <!-- Product Detail Modal -->
  <ProductDetailModal
    v-if="showProductDetailModal"
    :product="selectedProduct"
    :count="0"
    :isPackage="false"
    :isPackaging="false"
    :isPersonalizedCard="false"
    :selected="false"
    :isEditable="false"
    :type="'products'"
    @close-modal="showProductDetailModal = false"
  />
</template>

<script>
import { ref, onMounted } from 'vue';
import ProductDetailModal from './configurator/modals/ProductDetailModal.vue';
import { decodeHtml as decodeHtmlUtil } from './configurator/utils/productCountUtils.js';
import { Collapse } from 'bootstrap';

export default {
  name: 'ProductsSidebar',
  components: {
    ProductDetailModal,
  },
  props: {
    products: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const showProductDetailModal = ref(false);
    const selectedProduct = ref(null);

    const hasGroupedProducts = Object.values(props.products).some(
      (group) => group && group.length > 0,
    );

    const grouped = props.products;

    onMounted(() => {
      // Initialize Bootstrap collapses within products-sidebar only
      const sidebarEl = document.querySelector('.products-sidebar');
      if (sidebarEl) {
        sidebarEl.querySelectorAll('.collapse').forEach((element) => {
          new Collapse(element, { toggle: false });
        });
      }
    });

    const openProductModal = (product) => {
      selectedProduct.value = product;
      showProductDetailModal.value = true;
    };

    const decodeHtml = (html) => {
      return decodeHtmlUtil(html);
    };

    const getCategoryTitle = (type) => {
      const titles = {
        producten: 'Producten',
        'eten-drinken': 'Eten & drinken',
        verpakking: 'Verpakking',
        brievenbus: 'Brievenbus',
      };
      return titles[type] || type.charAt(0).toUpperCase() + type.slice(1);
    };

    return {
      showProductDetailModal,
      selectedProduct,
      hasGroupedProducts,
      grouped,
      openProductModal,
      decodeHtml,
      getCategoryTitle,
    };
  },
};
</script>
